import { TEMPLATE_SETTINGS } from '../type';

const initialState = {
    demandNameMap: null
};

export default function demandMap(state = initialState, action) {
    switch (action.type) {
        case TEMPLATE_SETTINGS.SET_DEMAND_NAME_MAP:
            return { ...state, demandNameMap: action.payload };
        default:
            return state;
    }
}
